import React, { useEffect, useRef } from 'react';
import { Animated, Easing, View, Platform } from 'react-native';
import Option from './Option';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
const CONTAINER_PADDING = 4;
const DIVIDER_WIDTH = 1;
const DIVIDER_MARGIN = 4;
export function ThemeSwitch({ theme, onChange, width }) {
    const styles = useStyleSheet(getStyles);
    const animValue = useRef(new Animated.Value(4)).current;
    const padding = 2 * CONTAINER_PADDING;
    const divider = 2 * DIVIDER_MARGIN + DIVIDER_WIDTH;
    const offset = width - padding - 2 * divider;
    const sliderWith = (width - padding - 2 * divider) / 3;
    const sliderPosition = {
        light: 4,
        dark: sliderWith + CONTAINER_PADDING + divider,
        auto: sliderWith * 2 + CONTAINER_PADDING + 2 * divider
    };
    const animationEnabled = useRef(false);
    const startAnimation = (toValue) => {
        Animated.timing(animValue, {
            toValue,
            duration: 375,
            easing: Easing.poly(2),
            useNativeDriver: Platform.OS !== 'web'
        }).start();
    };
    useEffect(() => {
        if (theme === 'auto') {
            startAnimation(sliderPosition.auto);
            return;
        }
        startAnimation(theme === 'light' ? sliderPosition.light : sliderPosition.dark);
    }, [animValue, offset]);
    const onClick = (v) => {
        animationEnabled.current = true;
        switch (v) {
            case 'light':
                startAnimation(sliderPosition.light);
                break;
            case 'dark':
                startAnimation(sliderPosition.dark);
                break;
            case 'auto':
                startAnimation(sliderPosition.auto);
                break;
        }
        onChange(v);
    };
    return (React.createElement(View, { style: [styles.container, { width }] },
        React.createElement(Animated.View, { style: [
                styles.slider,
                {
                    width: (width - padding - 2 * divider) / 3
                },
                { left: animationEnabled.current ? animValue : sliderPosition[theme] }
            ] }),
        React.createElement(Option, { iconName: 'light-theme', name: 'Light', value: 'light', onClick: onClick, animValue: animValue, offset: offset }),
        React.createElement(View, { style: styles.divider }),
        React.createElement(Option, { iconName: 'dark-theme', name: 'Dark', value: 'dark', offset: offset, onClick: onClick, animValue: animValue }),
        React.createElement(View, { style: styles.divider }),
        React.createElement(Option, { iconName: 'automatic-theme', name: 'Automatic', value: 'auto', offset: offset, animValue: animValue, onClick: onClick })));
}
const getStyles = createStyleSheet(({ color, size }) => {
    return {
        container: {
            height: 51,
            flexDirection: 'row',
            justifyContent: 'space-between',
            backgroundColor: color.bg.v2,
            padding: size.B,
            borderRadius: size.G
        },
        divider: {
            width: 1,
            marginVertical: size.D,
            backgroundColor: color.invert2.p4,
            marginHorizontal: size.B
        },
        slider: {
            position: 'absolute',
            height: 51 - 8,
            top: size.B,
            borderRadius: size.E,
            backgroundColor: color.bg.v3
        },
        text: { color: color.invert2.p100 },
        row: {
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
        }
    };
});
//# sourceMappingURL=index.js.map